export const dataEmployee = [
    { id: '1', name: 'Employee-1' },
    { id: '2', name: 'Employee-2' },
    { id: '3', name: 'Employee-3' },
    { id: '4', name: 'Employee-4' },
    { id: '5', name: 'Employee-5' },
    { id: '6', name: 'Employee-6' },
    { id: '7', name: 'Employee-7' },
    { id: '8', name: 'Employee-8' },
    { id: '9', name: 'Employee-9' },
    { id: '0', name: 'Employee-0' }]

